import * as ApiManager from './_manager';
import store from '@/store';

export const booking = {
  listEventBookings: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/bookings/listEventBookings`,
      payload
    );
  },
  get: (payload) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/bookings/get`,
      payload
    );
  },
  bookSeats : (payload) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/bookings/bookSeats`,
      payload
    );
  },
  cancelBooking : (payload) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/bookings/cancelBooking`,
      payload
    );
  }
};
